import React, { useEffect, forwardRef, useImperativeHandle } from 'react';

const TurnstileMock = forwardRef(({ onVerify }, ref) => {
  useEffect(() => {
    onVerify('MOCK_TOKEN_FOR_LOCAL_DEVELOPMENT');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run only on mount

  useImperativeHandle(ref, () => ({
    resetCaptcha: () => {
      onVerify('MOCK_TOKEN_FOR_LOCAL_DEVELOPMENT');
    },
  }));

  return <div className="turnstile-mock">Капча (мок для локальной разработки)</div>;
});

let TurnstileComponent;
if (["dev", "demo"].includes(process.env.REACT_APP_ENV)) {
  TurnstileComponent = TurnstileMock;
} else {
  // eslint-disable-next-line global-require
  TurnstileComponent = require("react-turnstile").default;
}

export default TurnstileComponent;
